import { render, staticRenderFns } from "./SupplierManufacturingEthical.vue?vue&type=template&id=71f9d3ac&scoped=true&"
import script from "./SupplierManufacturingEthical.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingEthical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9d3ac",
  null
  
)

export default component.exports